// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel-module__Carousel___2qtRU"};